import { Injectable, Output, EventEmitter, Inject } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { ApiService } from '../services/api.service';
import { REST_API_REQUEST_CALL_URL, Util } from '../utils/index';
import _ from 'lodash';
import { UserModel, VesselModel, OceanLineModel } from 'app/services';

export class Country {
  cntryCd:string;
  cntryNm:string;
  cntryPart:string;
  continent:string;
}

export class Location {
  cntryNm: string;
  type: string;
  cntryCd: string;
  name: string;
  locationId: number;
  latitude: number;
  longitude: number;
  unCd:string;
  locationCd:string
}

export class FareLocation extends Location{
  strStusCd:string;

  constructor() {
    super();
  }
}


export class Port extends Location {
  cntryNm: string;
  cntryNmKr: string;
  label: string;
  labelKr: string;
  portCd: string;
  portNm: string;
  portNmKr: string;
  timeZone: number;
  match:number
  fclScheduleCnt:number;
}

export class Airport extends Location {
  cntryNm: string;
  label: string;
  labelKr: string;
  portCd: string;
  portNm: string;
  timeZone: number;
}

export class City extends Location {
  cityCd:string;
  functionCd:string;
  nameWoDiacritics:string;
  suCode:string;
}

export class Address {
  address: string;
  city:string;
  latitude: number;
  longitude: number;
}

export class PortNmMapModel {
	portNmMapId:number;
	operCd:string;
	operTpNm:string;
	operTpCd:number;
	operPortNm:string;
	location:SaveLocationModel;
	stusNm:string;
	stusCd:number;
	modifyUser:UserModel;
	modifyDate:string;
	reqSystemNm:string;
	reqSystemCd:number;
	reqDtm:string;
  remark:string;
  isChecked:boolean;
}

export class SaveLocationModel {
  locationId:number;
  locationType:number;
  locationTypeNm:string;
  locationCd:string;
  cntryCd:string;
  cntryNm:string;
  name:string;
  nameKr:string;
  unCd:string;
  latitude:number;
  longitude:number;
  timeZone:number;
}

export class P2pScheduleSubModel {
  schSubId:string;
	schedule:any;
	seq:number;
	shprCd:string;
	vessel:VesselModel;
	vesselNm:string;
	vesselMapYn:string;
	voyage:string;
	srvcCd:string;
	depPortNm:string;
	depTmnlNm:string;
	depEta:string;
	depEtd:string;
	arrPortNm:string;
	arrTmnlNm:string;
	arrEta:string;
	arrEtd:string;
	oceanLine:OceanLineModel ;
	depLocation:Port;
	arrLocation:Port;
}


@Injectable()
export class CountryService {
  @Output() countryListEe: EventEmitter<Array<Country>> = new EventEmitter();
  countries: Array<Country>;
  ingFlag = false;
  constructor(private http: Http, private apiService:ApiService) {
    this.getCountries();
  };

  getCountries(){
    if(!this.countries || this.countries.length < 1){
      this.ingFlag = true;
      this.apiService.get(REST_API_REQUEST_CALL_URL.GET_COUNTRY_LIST_URL)
      .map(res => res)
      .subscribe(
        data => {
          this.ingFlag = false;
          this.countries = data;
          this.countryListEe.emit(this.countries);
        },
        err => {
          console.log("Error code: %s, URL: %s", err.status, err.url);
          this.ingFlag = false;
        },
        () => {}
      );
    }else{
      this.countryListEe.emit(this.countries);
    }
  }
} 



@Injectable()
export class CityService {
  constructor(private http: Http, private apiService:ApiService) {}

  getCities(cnrtyCd):Observable<Array<City>> {
    return this.apiService.get(REST_API_REQUEST_CALL_URL.GET_CITY_LIST_URL + cnrtyCd + '.json')
                        .map(res => res)
                        .map(res => {
                          let cityList = res.map(r => {
                            r.type='city';
                            return r;
                          });
                          return cityList;
                        });
  }
}


@Injectable()
export class PortService {
  @Output() portListEe: EventEmitter<Array<Port>> = new EventEmitter();
  ports: Array<Port>;
  ingFlag = false;
  constructor(private http: Http, private apiService:ApiService) {
    this.getPortList();
  }

  getPortList(){
    if(!this.ports || this.ports.length < 1){
      this.ingFlag = true;
      this.apiService.get(REST_API_REQUEST_CALL_URL.GET_PORT_LIST_URL).subscribe(
        res => {
          this.ports = _.map(res.data, d => {
            d.type = 'port';
            d.name = d.portNm;
            d.locationCd = d.portCd;
            d.labelKr = Util.getPortLabel(d.cntryNmKr, d.portNmKr, d.portCd);
            return d;
          });
          this.ingFlag = false;
          this.portListEe.emit(this.ports);
        },
        err => {
          console.log("Error code: %s, URL: %s", err.status, err.url);
          this.ingFlag = false;
        },
        () => {}
      );
    }else{
      this.portListEe.emit(this.ports);
    }
  }

  getPortListAndFclScheduleCnt(){
    return this.apiService.get('admin/ports');
  }

  getPortMapListByLocationId(locationId:number){
    return this.apiService.get('admin/ports/' + locationId + '/maps/');
  }

  getPortMapList(){
    return this.apiService.get('admin/ports/maps');
  }

  getPortMapListByStatus(status:number){
    return this.apiService.get('admin/ports/maps/status/' + status);
  }

  getPort(locationId:number){
    return this.apiService.get('admin/ports/'+ locationId);
  }

  postPort(porList:Array<SaveLocationModel>){
    let data = {portList : porList}
    return this.apiService.post('admin/ports', data);
  }

  patchPort(porList:Array<SaveLocationModel>){
    let data = {portList : porList}
    return this.apiService.patchReqDataType('admin/ports', data);
  }

  patchPortMap(portNmMapList:Array<PortNmMapModel>){
    let data = {portNmMapList : portNmMapList}
    return this.apiService.patchReqDataType('admin/ports/maps', data);
  }

  getTimeZone(lat, lng){
    return this.apiService.getTimeZone(lat, lng);
  }

  getFclScheduleSubLocationBroup(depLocationId:number, arrLocationId){
    return this.apiService.get('admin/fclScheduleSub/' + depLocationId + '/' + arrLocationId);
  }
}


@Injectable()
export class AirPortService {
  @Output() airPortListEe: EventEmitter<Array<Airport>> = new EventEmitter();
  airports: Array<Airport>;
  ingFlag = false;
  
  constructor(private http: Http, private apiService:ApiService) {
    this.getAirPortList();
  }

  getAirPortList(){
    if(!this.airports || this.airports.length < 1){
      this.ingFlag = true;
      this.apiService.get(REST_API_REQUEST_CALL_URL.GET_AIR_PORT_LIST_URL).subscribe(
        res => {
          this.airports = _.map(res.data, d => {
            d.type = 'air';
            d.locationCd = d.portCd;
            if(d.portNm != null) {
              d.name = d.portNm;
              d.portNm = d.portNm.replace(/international/gi, 'Int\'l').replace(/airport/gi, 'Apt.');            
            };
            if(d.label != null) {
              d.label = d.label.replace(/international/gi, 'Int\'l').replace(/airport/gi, 'Apt.');
            };

            d.labelKr = Util.getPortLabel(d.cntryNmKr, d.portNmKr, d.portCd);
            return d;
          });
          this.ingFlag = false;
          this.airPortListEe.emit(this.airports);
        },
        err => { 
          console.log("Error code: %s, URL: %s", err.status, err.url)
          this.ingFlag = false;
        },
        () => {}
      );
    }else{
      this.airPortListEe.emit(this.airports);
    }
  }
}


@Injectable()
export class LclPortService {
  @Output() portListEe: EventEmitter<Array<Port>> = new EventEmitter();
  ports: Array<Port>;


  constructor(private apiService: ApiService) {
    this.getLclPort();    
  }

  getLclPort(){
    if(!this.ports || this.ports.length < 1){
      this.apiService.get("lclport").subscribe( (res:any) => {
        if(res.result){
          this.ports = res.data.map(
            d => {
              d.type = 'port';
              d.name = d.portNm;
              d.locationCd = d.portCd;
              d.labelKr = Util.getPortLabel(d.cntryNmKr, d.portNmKr, d.portCd);
              return d;
            } 
          );
  
          this.portListEe.emit(this.ports);
        }
      });
    }else{
      this.portListEe.emit(this.ports);
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/services/locations.service.ts